import React from "react";
import InputMask from "react-input-mask";

const Campo = ({
  icon: Icon,
  label,
  error,
  mask,
  className = "",
  ...props
}) => (
  <div className="mb-2 w-full">
    {label && (
      <label className="block text-xs font-semibold text-gray-700 mb-1">
        {label}
      </label>
    )}
    <div className="flex items-center relative">
      {Icon && <Icon className="absolute left-3 text-gray-400" />}
      {mask ? (
        <InputMask
          {...props}
          mask={mask}
          className={`pl-9 border rounded-lg w-full p-2.5 bg-white outline-none focus:ring-2 focus:ring-blue-100 transition
            ${props.readOnly ? "bg-gray-100 cursor-not-allowed" : ""}
            ${error ? "border-red-400" : "border-gray-300"}
            ${className}
          `}
        />
      ) : (
        <input
          {...props}
          className={`pl-9 border rounded-lg w-full p-2.5 bg-white outline-none focus:ring-2 focus:ring-blue-100 transition
            ${props.readOnly ? "bg-gray-100 cursor-not-allowed" : ""}
            ${error ? "border-red-400" : "border-gray-300"}
            ${className}
          `}
        />
      )}
    </div>
    {error && <span className="text-xs text-red-500">{error}</span>}
  </div>
);

export default Campo;
